import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  // Check if Redux Persist has rehydrated
  const persistRehydrated = useSelector(
    (state) => state._persist?.rehydrated
  );
  
  // Check if country is selected in Redux store
  const selectedCountry = useSelector(
    (state) => state?.InterventionDetails?.filterListData?.country
  );
  
  // Wait for Redux Persist to rehydrate before making decisions
  if (!persistRehydrated) {
    return null; // or return <LoadingSpinner /> if you have one
  }
  
  // Always allow access to country-selection page
  if (location.pathname === "/country-selection") {
    return children;
  }
  
  // For all other routes, check if country is selected
  if (!selectedCountry) {
    return <Navigate to="/country-selection" replace />;
  }
  
  return children;
};

export default ProtectedRoute;